<template>
  <div class="board-form">
    <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">
      <b-card no-body>
        <b-card-header>
          <strong>投稿</strong>
        </b-card-header>
        <b-card-body>
          <b-form-group label="" label-cols-md="2" label-align-md="right">
            <b-badge variant="info" v-if="form.id">
              {{ form.number }}番を編集中
            </b-badge>
          </b-form-group>
          <b-form-group label="タイトル:" label-cols-md="2" label-align-md="right">
            <FormValidatorText name="タイトル" :form="$v.form.subject" />
          </b-form-group>
          <b-form-group label="本文:" label-cols-md="2" label-align-md="right">
            <FormValidatorTextarea name="本文" :form="$v.form.message" :rows="10" ref="message" />
          </b-form-group>
          <b-form-group label-cols-md="2" label-align-md="right">
            <FormValidatorCheckbox :form="$v.form.is_send">メールを送信する</FormValidatorCheckbox>
          </b-form-group>
        </b-card-body>
        <b-card-footer>
          <b-button type="submit" variant="primary">投稿</b-button>
          <b-button type="reset" variant="outline-primary">リセット</b-button>
        </b-card-footer>
      </b-card>
    </b-form>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { required, maxLength } from 'vuelidate/lib/validators';

export default {
  name: 'BoardForm',

  computed: {
    ...mapState({
      form: state => state.posts.form,
    }),

    subject: {
      get() {
        return this.form.subject;
      },
      set(value) {
        this.$store.dispatch('posts/inputSubject', value);
      },
    },

    message: {
      get() {
        return this.form.message;
      },
      set(value) {
        this.$store.dispatch('posts/inputMessage', value);
      },
    },
  },

  validations: {
    form: {
      subject: {
        maxLength: maxLength(255),
      },
      message: {
        required,
        maxLength: maxLength(65536),
      },
      is_send: {
      },
    },
  },

  methods: {
    onSubmit(evt) {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return;
      }
      if (this.form.id) {
        this.$store.dispatch('posts/updateItem', {
          form: this.form,
          callback: (data) => {
            this.$v.form.$reset();
            this.$store.dispatch('posts/clearForm');
          },
        });
      } else {
        this.$store.dispatch('posts/addItem', {
          form: this.form,
          callback: (data) => {
            this.$v.form.$reset();
            this.$store.dispatch('posts/clearForm');
          },
        });
      }
    },

    onReset(evt) {
      this.$v.form.$reset();
      this.$store.dispatch('posts/clearForm');
    },
  },

  mounted() {
    this.$emit('refsMessage', this.$refs.message);
  },
};
</script>

<style scoped>
>>> .badge {
  font-size: 100%;
}
</style>
